module.exports = __webpack_public_path__ + "static/media/screenings.d5e179d9.png";